import React from 'react';

export default function ScoreRing({ score, color, size = 120 }) {
  const r    = size / 2 - 10;
  const circ = 2 * Math.PI * r;
  const pct  = Math.min(score / 100, 1);

  return (
    <svg width={size} height={size} className="score-ring-svg" style={{ transform: 'rotate(-90deg)', display:'block' }}>
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth={8} />
      <circle
        cx={size/2} cy={size/2} r={r}
        fill="none"
        stroke={color}
        strokeWidth={8}
        strokeDasharray={circ}
        strokeDashoffset={circ * (1 - pct)}
        strokeLinecap="round"
        style={{ transition: 'stroke-dashoffset 1.2s cubic-bezier(0.4,0,0.2,1)' }}
      />
    </svg>
  );
}
